module.exports = __webpack_public_path__ + "d5247adfed45820a3585118b4e440047.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/social/facebook-c.png
// module id = 657
// module chunks = 47